<template>
  <div class="my-12 overflow-hidden">
    <div class="container">
      <h2
        v-blokkli-editable:field_title
        class="mb-10 text-3xl md:text-4xl lg:mb-14"
      >
        {{ title }}
      </h2>
    </div>
    <div class="relative">
      <BlokkliField
        v-slot="{ items }"
        name="field_slides"
        :list="slides"
        proxy-mode
      >
        <ParagraphCarouselSlider
          :key="items.map((v) => v.uuid).join('-')"
          :slides="items"
          :class="{
            'pointer-events-none': isEditing,
          }"
        />
      </BlokkliField>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphCarouselFragment } from '#graphql-operations'
import type { FieldListItemTyped } from '#blokkli-build/generated-types'

defineProps<{
  slides: FieldListItemTyped[]
  title: ParagraphCarouselFragment['title']
}>()

const isEditing = false
defineBlokkli({
  bundle: 'carousel',
  editor: {
    editTitle: (el) => el.querySelector('h2')?.textContent,
  },
  propsFieldMapping: {
    title: { type: 'editable', name: 'field_title' },
    slides: { type: 'field', name: 'field_slides' },
  },
})
</script>

<style>
@reference "~/assets/css/tailwind.css";

.swiper {
  @apply overflow-visible;
}
</style>
